import { twMerge } from "tailwind-merge";

interface ToggleProps {
  children: React.ReactNode;
  className?: string;
}
export const ToggleLayout = ({ children, className }: ToggleProps) => {
  return (
    <div
      className={twMerge(
        "gg-grid gg-grid-cols-2 gg-border-collapse",
        className
      )}
    >
      {children}
    </div>
  );
};
